<template>
  <div id="app">
    <div class="swpTax-calculator">
      <div class="row">
        <div class="col-lg-12">
          <div class="card swpTax-border">
            <div class="card-body">
              <v-form @submit.prevent="submitForm">
                <div class="col-md-12">
                  <div class="swpTax-input">
                    <label for="corpus" class="label-spacing"
                      >Corpus Amount</label
                    >
                    <span class="swpTax-group">
                      <div class="rupees-symbol">₹</div>
                      <input
                        type="text"
                        class="form-control"
                        v-model="formData.corpus"
                        outlined
                        id="corpus"
                      />
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="swpTax-input">
                    <label for="expense" class="label-spacing"
                      >Annual Expense</label
                    >
                    <span class="swpTax-group">
                      <div class="rupees-symbol">₹</div>
                      <input
                        type="text"
                        class="form-control"
                        v-model="formData.expense"
                        outlined
                        id="expense"
                      />
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="swpTax-input">
                    <label for="return" class="label-spacing"
                      >Expected return</label
                    >
                    <span class="swpTax-group">
                      <button type="button" @click="decreaseReturns">-</button>
                      <input
                        class="form-control text-center"
                        type="text"
                        v-model="formData.returnRate"
                        outlined
                        id="return"
                      />
                      <button type="button" @click="increaseReturns">+</button>
                    </span>
                  </div>
                  <div class="swpTax-input">
                    <label for="inflation" class="label-spacing"
                      >Inflation rate (%)</label
                    >
                    <span class="swpTax-group">
                      <button type="button" @click="decreaseInflation">
                        -
                      </button>
                      <input
                        type="text"
                        v-model="formData.inflationRate"
                        class="form-control text-center"
                        outlined
                        id="inflation"
                      />
                      <button type="button" @click="increaseInflation">
                        +
                      </button>
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="swpTax-input">
                    <label for="tax" class="label-spacing"
                      >Taxation Rate (%):</label
                    >
                    <span class="swpTax-group">
                      <button type="button" @click="decreaseTimePeriod">
                        -
                      </button>
                      <input
                        class="form-control text-center"
                        type="text"
                        v-model="formData.taxRate"
                        outlined
                        id="tax"
                      />
                      <button type="button" @click="increaseTimePeriod">
                        +
                      </button>
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <button
                      type="button"
                      @click="submitForm()"
                      class="swpTax-button"
                    >
                      Calculate
                    </button>
                  </div>
                </div>
              </v-form>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="swpTax_results" v-if="showResults">
        <div class="col-lg-12">
          <div class="second-card">
            <div class="row">
              <div class="card swpTax-border-card">
                <div class="card-body swpTax-card-color">
                  <h4 class="swpTax-final">
                    Your corpus will last for
                    <span
                      :style="{ color: corpusYears === 60 ? '#DC4B00' : '' }"
                    >
                      {{
                        results.length === 60
                          ? "over " + results.length + " years"
                          : results.length + " years"
                      }}
                    </span>
                  </h4>
                </div>
                <p style="text-align: center">
                  The table below shows you the year-wise change in expenses and
                  corpus
                </p>
              </div>
            </div>
          </div>
        </div>
        <table class="swpTax-table">
          <thead>
            <tr class="swpTax-data">
              <th style="border: 1px solid #000; padding: 8px">Year</th>
              <th style="border: 1px solid #000; padding: 8px">
                Annual Expense
              </th>
              <th style="border: 1px solid #000; padding: 8px">
                Corpus Balance
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(result, index) in results"
              :key="index"
              style="border: 1px solid #000"
            >
              <td style="border: 1px solid #000; padding: 8px">
                {{ result.year }}
              </td>
              <td style="border: 1px solid #000; padding: 8px">
                {{ result.expense }}
              </td>
              <td style="border: 1px solid #000; padding: 8px">
                {{ result.corpus }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="swpTax-dis">
          <i class="swpTax-disclaim"
            >Disclaimer: Withdrawals assumed at the beginning of the
            year.Returns added at the end of the year</i
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SWPTax",
  data() {
    return {
      formData: {
        returnRate: "12 %",
        corpus: null,
        expense: null,
        inflationRate: "2 %",
        taxRate: "0 %",
      },
      results: [],
      showResults: false,
      returnRates: [
        0.04, 0.05, 0.06, 0.07, 0.08, 0.09, 0.1, 0.11, 0.12, 0.13, 0.14,
      ],
      inflationRates: [0.02, 0.03, 0.04, 0.05, 0.06, 0.07, 0.08, 0.09, 0.1],
      taxRates: [0, 0.05, 0.1, 0.15, 0.2, 0.3],
    };
  },
  methods: {
    submitForm() {
      this.calculate();
    },
    increaseInflation() {
      const numericValue = parseFloat(this.formData.inflationRate);
      if (numericValue < 14) {
        this.formData.inflationRate = `${numericValue + 1} %`;
      }
    },
    decreaseInflation() {
      const numericValue = parseFloat(this.formData.inflationRate);
      if (numericValue > 1) {
        this.formData.inflationRate = `${numericValue - 1} %`;
      }
    },
    increaseReturns() {
      const numericValue = parseFloat(this.formData.returnRate);
      if (numericValue < 50) {
        this.formData.returnRate = `${numericValue + 1} %`;
      }
    },
    decreaseReturns() {
      const numericValue = parseFloat(this.formData.returnRate);
      if (numericValue > 1) {
        this.formData.returnRate = `${numericValue - 1} %`;
      }
    },
    increaseTimePeriod() {
      const numericValue = parseFloat(this.formData.taxRate);
      if (numericValue < 30) {
        this.formData.taxRate = `${numericValue + 5} %`;
      }
    },
    decreaseTimePeriod() {
      const numericValue = parseFloat(this.formData.taxRate);
      if (numericValue > 0) {
        this.formData.taxRate = `${numericValue - 5} %`;
      }
    },
    calculate() {
      this.showResults = true;
      this.results = [];
      let corpus = parseFloat(this.formData.corpus);
      let expense = parseFloat(this.formData.expense);
      let returnRate = parseFloat(this.formData.returnRate) / 100;
      let inflationRate = parseFloat(this.formData.inflationRate) / 100;
      let taxRate = parseFloat(this.formData.taxRate) / 100;
      let years = 0;
      let taxOutflow = 0;

      while (years < 60 && taxOutflow >= 0 && corpus > 0) {
        years++;
        if (taxRate > 0) {
          taxOutflow = (corpus - expense) * returnRate * taxRate;
        } else {
          taxOutflow = 0;
        }

        corpus = (corpus - expense) * (1 + returnRate) - taxOutflow;
        if (corpus > 0) {
          this.results.push({
            year: years,
            expense: Math.round(expense + taxOutflow),
            corpus: Math.round(corpus),
          });
        }
        expense = expense * (1 + inflationRate);
      }
    },
  },
};
</script>

<style scoped>
.swpTax-calculator .swpTax-input label {
  display: block;
  font-weight: bold;
  text-align: justify;
  font-size: 16px;
  color: #012e40 !important;
}

.swpTax-input input {
  text-align: justify;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.swpTax-table {
  border-collapse: collapse;
  text-align: center;
  margin: auto;
}

.swpTax-calculator .swpTax-input button {
  background: transparent;
  border: none;
  color: #000000;
}

.swpTax_results {
  position: relative;
  margin-top: -60px;
}

.swpTax-data {
  background-color: #00a3d9;
  color: white;
  font-size: large;
}

.swpTax-final {
  background-color: #38e2b233;
  padding: 10px;
  text-align: center;
  font-weight: 800;
  margin-bottom: 10px;
  color: #012e40;
}

.swpTax-group {
  display: flex;
  border: 1px solid #e5e5e5;
  margin: 0 0 10px;
  border-radius: 8px;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
}

.label-spacing {
  margin-bottom: 0.7rem;
  display: flex;
}

.swpTax-border {
  border: none;
  outline: none;
  background: none;
}

.swpTax-calculator {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 1%;
}

.second-card {
  border: none !important;
  border-radius: 10px;
}

.swpTax-dis {
  padding: inherit;
  margin: 5px 0px 0px 14px;
}

.rupees-symbol {
  display: flex;
  font-size: 14px;
  color: #555;
  margin: 5px;
}

.swpTax-border-card {
  border: none;
}

.swpTax-card-color {
  border-radius: 10px;
}

.swpTax-card-label {
  font-weight: bold;
  text-align: center;
}

.swpTax-card-input {
  text-align: center;
  border: none;
  outline: none;
  background: transparent;
}

.swpTax-button {
  width: 100%;
  background: #00a3d9;
  color: white;
  padding: 0.6em;
  margin: 0px 0 12px;
  border-radius: 5px;
}

.swpTax-disclaim {
  color: #918d99;
  font-size: 14px;
}
</style>
